// extracted by mini-css-extract-plugin
module.exports = {"printButton":"OrderSummarySegment-PrintButton-module--print-button--Lsqd2 responsive-module--no-print--TgwWP"};